import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn('API request made without token:', config.url);
  }
  return config;
});

// Handle errors
let isRedirecting = false; // Prevent multiple redirects

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 errors
    if (error.response?.status === 401 && error.config?.url !== '/auth/login') {
      // Clear invalid/expired token
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Redirect to login (only once)
      if (!isRedirecting && window.location.pathname !== '/login') {
        isRedirecting = true;
        console.warn('Token expired or invalid. Redirecting to login...');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;

